module.exports = __webpack_public_path__ + "static/arenafighttv-3ef69bc7516d9d1a0fb0b34666c42a29.png";